import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider.module.js';

if (document.querySelector('.historySlider__carousel')) {
    let historySlider = tns({
        container: '.historySlider__carousel',
        items: 1,
        loop: false,
        center: true,
        controls: false,
        nav: false,
        fixedWidth: 280,
        responsive: {
            480: {
                fixedWidth: 400
            },
            660: {
                fixedWidth: 600
            }
        }
    });

    let buttons = document.querySelectorAll('.historySlider__navButton');

    for (let i = 0; i < buttons.length; i++) {
        let button = buttons[i];

        button.addEventListener('click', () => {
            historySlider.goTo(i);
        });
    }

    historySlider.events.on('indexChanged', (info) => {
        let indexPrev = info.indexCached;
        let indexCurrent = info.index;

        info.slideItems[indexPrev].classList.remove('isActive');
        info.slideItems[indexCurrent].classList.add('isActive');

        buttons[indexPrev].classList.remove('isActive');
        buttons[indexCurrent].classList.add('isActive');
    });
}



// WEBPACK FOOTER //
// ./src/components/historySlider/historySlider.js